import { Storage } from '@24i/nxg-sdk-quantum';
import {
    ASYNC_STORAGE_KEY_MOCK_DEVICES,
    ASYNC_STORAGE_KEY_USER,
    ASYNC_STORAGE_KEY_USER_TOKEN,
} from '@24i/nxg-core-utils/src/constants';
import {
    ANALYTICS_EVENTS,
    ANALYTICS_TRIGGERS,
    onAnalytics,
    setUserInfo,
} from '@24i/nxg-sdk-smartott-shared/src/analytics';

export const removeUserDataFromStorage = async (): Promise<void> => {
    await Storage.removeItem(ASYNC_STORAGE_KEY_MOCK_DEVICES); // Remove when mocked behaviour not necessary anymore
    await Storage.removeItem(ASYNC_STORAGE_KEY_USER);
    await Storage.removeItem(ASYNC_STORAGE_KEY_USER_TOKEN);
};

export const sendLogoutAnalytics = () => {
    setUserInfo(null);
    onAnalytics(ANALYTICS_TRIGGERS.LOGOUT, { event: ANALYTICS_EVENTS.LOGGED_OUT });
};
